export default {
  reset: function reset() {
    if (window.mixpanel) {
      window.mixpanel.reset();
    }
  }
};